<template>
  <div>
    <Head title="Na vlerëso!" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/vleresimet">Vlerësimet</Link>
      <span class="text-indigo-400 font-medium">/</span> Regjistro
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <select-input v-model="form.service_id" :error="form.errors.service_id" class="pb-8 pr-6 w-full" label="Shërbimi">
            <option v-for="service in services" :key="service.id" :value="service.id">{{ service.name }}</option>
          </select-input>

          <div v-if="cities_show" class="pb-8 pr-6  w-full">
            <label class="form-label">Qyteti:</label>
            <Multiselect
              v-model="form.city_ids"
              :options="filterCities.options"
              :error="form.errors.city_ids"
              mode="tags"
              :close-on-select="false"
              :searchable="true"
              :create-option="false"
              :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
            />
            <div v-if="form.errors.city_ids" class="form-error">{{ form.errors.city_ids }}</div>
          </div>

          <select-input v-model="form.rate_id" :error="form.errors.rate_id" class="pb-8 pr-6 w-full" label="Nota">
            <option v-for="rate in rates" :key="rate.id" :value="rate.id">{{ rate.name }}</option>
          </select-input>

          <textarea-input v-model="form.suggestion" :error="form.errors.suggestion" class="pb-8 pr-6 w-full" label="Sygjerimi" />

        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Vlerëso</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Select2 from 'vue3-select2-component'
import Multiselect from '@vueform/multiselect'
import TextareaInput from '@/Shared/TextareaInput'


export default {
  components: {
    TextareaInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    Select2,
    Multiselect
  },
  layout: Layout,
  props: {
    services: Object,
    cities: Object,
    rates: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        service_id: null,
        city_ids: null,
        rate_id: null,
        suggestion: null
      }),
      filterCities: {
        options: this.cities.map(function(city){
          return {value: city.id, label: city.name}
        }),
      },
      cities_show: false
    }
  },
  methods: {
    store() {
      this.form.post('/vleresimet')
    },

  },
  watch: {
    'form.service_id'(newValue){
      this.cities_show = (newValue === 1 || newValue === 2)
    }
  }
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
